import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Confirmation, StyledLink, StyledNoLink } from './ActionLink.style'

class ActionLink extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
        confirmation: PropTypes.node,
        confirmationTimeout: PropTypes.number,
        onClick: PropTypes.func,
        openConfirmation: PropTypes.func,
        confirmationContent: PropTypes.string,
        confirmationHeader: PropTypes.string,
        openForm: PropTypes.func,
        width: PropTypes.string,
        id: PropTypes.string,
        noCursor: PropTypes.bool,
        noLink: PropTypes.bool,
    }

    static defaultProps = {
        className: '',
        confirmation: null,
        confirmationTimeout: 3000,
        onClick: null,
        openConfirmation: null,
        openForm: null,
        confirmationContent: 'Content',
        confirmationHeader: 'Header',
        id: null,
        width: null,
        noCursor: false,
        noLink: false,
    }

    constructor(props) {
        super(props)

        this.state = {
            showConfirmation: false,
        }

        this.onClick = this.onClick.bind(this)
    }

    componentWillUnmount = () => {
        this.clearTimeout()
    }

    clearTimeout = () => {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    onClick(e) {
        const { confirmation, confirmationTimeout, onClick } = this.props

        if (confirmation) {
            this.setState({ showConfirmation: true }, () => {
                this.clearTimeout()
                this.timeout = setTimeout(() => this.setState({ showConfirmation: false }), confirmationTimeout)
            })
        }

        if (onClick) onClick(e)
    }

    openConfirm = (e) => {
        const { openConfirmation, confirmationHeader, confirmationContent } = this.props
        if (openConfirmation) openConfirmation(this.onClick, confirmationHeader, confirmationContent)
        else this.onClick(e)
    }

    openForm = (e) => {
        const { openForm, openConfirmation, confirmationHeader, confirmationContent, id } = this.props
        if (openForm && openConfirmation) openForm(id, this.onClick, confirmationHeader, confirmationContent)
        else if (openForm) openForm()
        else this.openConfirm(e)
    }

    render() {
        const { children, confirmation, className, width, noCursor, noLink } = this.props
        const { showConfirmation } = this.state
        return (
            <Fragment>
                {noLink && (
                    <StyledNoLink onClick={this.openForm} className={className} width={width} noCursor={noCursor}>
                        {children}
                    </StyledNoLink>
                )}
                {!noLink && (
                    <StyledLink onClick={this.openForm} className={className} width={width} noCursor={noCursor}>
                        {children}
                    </StyledLink>
                )}
                {confirmation && <Confirmation show={showConfirmation}>{confirmation}</Confirmation>}
            </Fragment>
        )
    }
}

export default ActionLink
